import React, { useEffect, useMemo, useState } from 'react';
import FormModal from '../common/form/FormModal';
import AttributeEditor from './AttributeEditor';
import { Attribute, AvailableTypeEnum, parseMetadataToFields } from './attributes';

type AttributeEditorModalProps = {
    attributes: Attribute[];
    isOpen: boolean;
    onSave: (value) => void;
    onCancel: () => void;
    group: string;
    saveButtonLabel?: string;
    enableValidationRules?: boolean;
};

export default (props: AttributeEditorModalProps) => {
    const { attributes, isOpen, onSave, onCancel, group, saveButtonLabel, enableValidationRules } = props;
    const [fields, setFields] = useState([]);

    useEffect(() => {
        const fieldsFromAttributes = [];
        if (attributes) {
            attributes.forEach((attr) => {
                const { value, ...otherFields } = attr;
                fieldsFromAttributes.push({ ...otherFields });
            });
        }
        setFields(parseMetadataToFields(fieldsFromAttributes));
    }, [attributes]);

    const initialValues = useMemo(() => {
        const obj = {};
        if (attributes) {
            parseMetadataToFields(attributes).forEach((attr) => {
                if (attr.fieldType === AvailableTypeEnum.measurement) {
                    const valuesJSON = attr?.value ? JSON.parse(attr.value) : [];
                    obj[attr.name] = valuesJSON.value;
                    obj[attr.name + 'unit'] = valuesJSON?.unit ? valuesJSON.unit : attr?.unit;
                } else {
                    obj[attr.name] = attr.value;
                }
            });
        }

        return obj;
    }, [attributes]);
    return (
        <FormModal
            id={group}
            title={group}
            isOpen={isOpen}
            hideButtons
            onClose={() => {
                onCancel();
            }}
        >
            {attributes && (
                <AttributeEditor
                    fields={fields}
                    initialValues={initialValues}
                    onSave={(attr) => {
                        const returnedAttributes = attributes
                            .map((attribute) => {
                                const { value, ...otherAttributeFields } = attribute;
                                if (attribute.fieldType === AvailableTypeEnum.measurement) {
                                    return {
                                        ...otherAttributeFields,
                                        value: JSON.stringify({
                                            value: attr[attribute?.name],
                                            unit: attr[attribute?.name + 'unit']
                                        })
                                    };
                                }
                                if (attribute.fieldType === AvailableTypeEnum.boolean) {
                                    return {
                                        ...otherAttributeFields,
                                        value: attr[attribute.name] ?? false
                                    };
                                }
                                if (attr[attribute?.name]) {
                                    return { ...otherAttributeFields, value: attr[attribute.name] };
                                }
                            })
                            .filter(Boolean);

                        onSave(returnedAttributes);
                    }}
                    onCancel={onCancel}
                    saveButtonLabel={saveButtonLabel}
                    enableValidationRules={enableValidationRules}
                />
            )}
        </FormModal>
    );
};
